// Flag per azienda dei moduli principali: spenti solo se valgono false,
// così una riga azienda senza il campo (sessione vecchia) li mostra come oggi.
export const MODULE_FLAGS = {
  TIMESHEET: 'feature_timesheet',
  DOCUMENTS: 'feature_documents',
  COMMUNICATIONS: 'feature_communications',
  DEADLINES: 'feature_deadlines',
  REPORTS: 'feature_reports',
  PAYROLL_DATA: 'feature_payroll_data',
  PROJECTS: 'feature_projects',
  TOOLS: 'feature_tools',
  DOCUMENT_GENERATION: 'feature_document_generation',
  SIGNATURES: 'feature_signatures',
};

// Moduli su richiesta: accesi solo se valgono true, come le anteprime.
export const OPT_IN_MODULE_FLAGS = {
  AUTO: 'feature_auto',
};

// Funzioni in anteprima: accese solo se valgono true.
export const PREVIEW_FLAGS = {
  ORG_CHART: 'feature_org_chart',
  LABOR_COST_BUDGET: 'feature_labor_cost_budget',
  EMPLOYEES_RESIDUALS: 'feature_employees_residuals',
  CUSTOM_REPORT: 'feature_custom_report',
  PAY_TRANSPARENCY: 'feature_pay_transparency',
  CONNECT_API: 'feature_connect_api',
  MENU_V2: 'company_menu_v2',
};

export function isModuleEnabled(company, flag) {
  return company?.[flag] !== false;
}

export function isPreviewEnabled(company, flag) {
  return company?.[flag] === true;
}

export function getCurrentCompany(user) {
  return user?.data?.companies?.[user?.data?.current_company];
}
